import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ChopKatalog } from '@entity/chop';
import { ChopService } from '@service/chop.service';

export const ChopKatalogeResolve: ResolveFn<ChopKatalog[]> = () => inject(ChopService).getKataloge();
